import json from './insight-data.json'
const dW = 1280;
const dH = 6249;
const sW = window.innerWidth;
const sH = window.innerHeight;

export const pixelRatioWidth =  (w) => {
    const W = (w/dW)*sW;
    return Math.floor(W);
}

export const pixelRatioHeight =  (h) => {
    const H = (h/dH)*sH;
    return H;
}
export const getLocInfo = (location) => {
    const insight = location.pathname.split('/');
    const module = insight[2] === 'success-story'?'success':insight[2] === 'intel-ideas'?'intel':'whats';
    const slug = "/" + insight[3];
    return {
        module,
        slug
    }
}


export const getModuleData = (module) => {
    try {
        const {items,...rest} = json[module];
        if(items){
            rest.main = items.find(a => a.feature === true);
            rest.items = items.filter(a => a.feature === false && a.publish === true);
        }
        
        return rest;
        
    } catch (error) {
        return error;
    }
    
}

export const getItem = (module,slug,main=false) => {
    const data = json[module];
    const list = data.items.filter(a => a.slug === slug)
    return list?list[0]:{}
}
const getAllAricles = () => {
    const articles = [...json['success']['items'],...json['intel']['items'],...json['whats']['items']];
    return articles||[];
}
export const getRelatedArticles = (module,items) => {
    
    const articles = getAllAricles();
    const articlesArr= items.map(item => articles.find(a => a.slug === item))
  
    const list = articlesArr.map(item => {
        const {banner,eyebrowText,slug,title,category} = item;
        return {
            banner,eyebrowText,slug,title,category
        }
    })
    return list?list:[]
}

export const getItemBaseUrl = (slug) => {
    
    const articles = getAllAricles();
    
    const item = articles.find(a => a.slug === slug);
    
    return item?item.base_url:null;
}
export const getArticleCategory = (slug) => {
    
    const articles = getAllAricles();
    
    const item = articles.find(a => a.slug === slug);
    
    return item?item.category:null;
}
export const renameCategory = name => {
    if(name === 'whats-news'){
      return 'whats'
    } else if(name === 'intel-ideas'){
      return 'intel'
    } else {
      return 'success'
    }
  }
export const getInsightTabPath = tab => {
    if(tab === 'whats'){
      return 'whats-news'
    } else if(tab === 'intel'){
      return 'intel-ideas'
    } else {
      return 'success-story'
    }
  }
export const getArticleInfo = (slug) => {
    
    const articles = getAllAricles();
    
    const item = articles.find(a => a.slug === slug);
    
    return item?item:{};
}
export const scrollToTop = () => {
        window.scrollTo({
      top: 0,
      behavior: 'instant',
    });
  };
// export const scrollMiddle =()=>{
//   window.scrollTo({
//     top:500,
//     behavior:'instant',
//   })
// }


export const handleEmailClick = (email,subject,body) => {
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

export const handleLinkedInShare = (url) => {
    const screenHeight = sH || document.documentElement.clientHeight || window.screen.height
    const screenWidth = sW || document.documentElement.clientWidth || window.screen.width
    const left = (screenWidth- 400)/2
    const top =(screenHeight-600)/2

    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url )}`,"_blank",`width=400,height=600,top=${top},left=${left}` );
  };

  export function slugify(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
    str = str.toLowerCase(); // convert string to lowercase
    str = str.replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
             .replace(/\s+/g, '-') // replace spaces with hyphens
             .replace(/-+/g, '-'); // remove consecutive hyphens
    return str;
  }